import { NextSeo } from "next-seo";
import Link from "next/link";
import React from "react";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

function Blog() {
  return (
    <>
      <div className="articleHeader">
        <NextSeo title="Blog" />
        <div className="top-banner">
          <div className="copy">
            <h1>Blog</h1>
          </div>
        </div>
      </div>
      <div className="privacy">
        <div className="text">
          <div className="tag">
            <div className="imageContainer">
              <div className="image">
                <img
                  src={`${publicRuntimeConfig.basePath}/trademarkarticle1.jpg`}
                  alt=""
                  layout="fill"
                />
              </div>
            </div>
            <Link href="/articles/How-To-Register-a-Trademark-Online"><a><h4>How To Register a Trademark Online</h4></a></Link>
            <p>
              Trademark registration is an important step for businesses, as it helps to protect the unique branding and
              identity of your company. In this article, we will go through the process of registering a trademark
              online
              in a step-by-step guide.
            </p>
            <div className="dateContainer">
              <div className="date">December 10th, 2022</div>
              <Link href="/articles/How-To-Register-a-Trademark-Online">
                <a className="orange-btn" style={{ width: "auto", paddingTop: "10px", paddingBottom: "10px" }}>Read
                  more</a>
              </Link>
            </div>
          </div>
          <hr />
          <div className="tag">
            <Link href="/articles/Should-I-use-a-trademark-filing-service"><a><h4>Should I use a trademark filing service?</h4></a></Link>
            <p>
              When it comes to registering a trademark, businesses have the option of using a trademark registration
              service or going through the process themselves. While it is certainly possible to register a trademark on
              your own, there are several compelling reasons to consider using a trademark registration service to help
              you navigate the process.
            </p>
            <div className="dateContainer">
              <div className="date">December 15th, 2022</div>
              <Link href="/articles/Should-I-use-a-trademark-filing-service">
                <a className="orange-btn" style={{ width: "auto", paddingTop: "10px", paddingBottom: "10px" }}>Read
                  more</a>
              </Link>
            </div>
          </div>
          <hr />
          <div className="tag">
            <div className="imageContainer">
              <div className="image">
                <img
                  src={`${publicRuntimeConfig.basePath}/trademarkarticle3.jpg`}
                  alt=""
                  layout="fill"
                />
              </div>
            </div>
            <Link href="/articles/Copyright-vs-Trademarking"><a><h4>Copyright vs Trademarking</h4></a></Link>
            <p>
              When it comes to protecting your creative works and intellectual property, it's important to understand
              the
              differences between trademarking and copyrighting. These two legal concepts are often confused, but they
              serve different purposes and offer different types of protection. In this article, we'll explain the key
              differences between trademarking and copyrighting and help you understand when to use each one.
            </p>
            <div className="dateContainer">
              <div className="date">December 18th, 2022</div>
              <Link href="/articles/Copyright-vs-Trademarking">
                <a className="orange-btn" style={{ width: "auto", paddingTop: "10px", paddingBottom: "10px" }}>Read
                  more</a>
              </Link>
            </div>
          </div>
          <hr />
          <div className="tag">
            <div className="imageContainer">
              <div className="image">
                <img
                  src={`${publicRuntimeConfig.basePath}/trademarkarticle2.jpg`}
                  alt=""
                  layout="fill"
                />
              </div>
            </div>
            <Link href="/articles/Do-I-Need-a-Trademark"><a><h4>Do I Need a Trademark?</h4></a></Link>
            <p>
              If you're a business owner, artist, or creator of any kind, you probably have a lot of ideas and
              intellectual property that you want to protect. One way to do this is by trademarking your creations. But
              what is a trademark, and when do you need one? Here's what you need to know if you're considering
              trademarking something.
            </p>
            <div className="dateContainer">
              <div className="date">December 27th, 2022</div>
              <Link href="/articles/Do-I-Need-a-Trademark">
                <a className="orange-btn" style={{ width: "auto", paddingTop: "10px", paddingBottom: "10px" }}>Read
                  more</a>
              </Link>
            </div>
          </div>
          <hr />
          <div className="tag">
            <div className="imageContainer">
              <div className="image">
                <img
                  src={`${publicRuntimeConfig.basePath}/trademarkarticle5.jpg`}
                  alt=""
                  layout="fill"
                />
              </div>
            </div>
            <Link href="/articles/Trademark-Office-Actions-What-to-Know-and-What-to-Do"><a><h4>Trademark Office Actions: What to Know and What to Do</h4></a></Link>
            <p>
              If you've applied for a trademark, you may receive a trademark office action from the United States Patent
              and Trademark Office (USPTO). A trademark office action is a notice from the USPTO that there is an issue
              with your trademark application and that you need to take action to address the issue. Receiving a
              trademark
              office action can be frustrating and confusing, but it's important to understand what it means and how to
              respond. Here's what you need to know about trademark office actions and what to do if you receive one.
            </p>
            <div className="dateContainer">
              <div className="date">December 29th, 2022</div>
              <Link href="/articles/Trademark-Office-Actions-What-to-Know-and-What-to-Do">
                <a className="orange-btn" style={{ width: "auto", paddingTop: "10px", paddingBottom: "10px" }}>Read
                  more</a>
              </Link>
            </div>
          </div>
          <hr />
          <div className="tag">
            <div className="imageContainer">
              <div className="image">
                <img
                  src={`${publicRuntimeConfig.basePath}/trademarkarticle6.png`}
                  alt=""
                  layout="fill"
                />
              </div>
            </div>
            <Link href="/articles/Do-I-need-Trademark-Monitoring"><a><h4>Do I need Trademark Monitoring?</h4></a></Link>
            <p>
              Trademark monitoring is the process of regularly checking for the use of trademarks that are similar to
              your own in order to ensure that your brand is not being infringed upon. This is an important step for
              businesses of all sizes, as it can help to protect your intellectual property and prevent costly legal
              battles. A trademark monitoring service can make this process easier and more effective by regularly
              conducting searches on your behalf and alerting you to any potential infringing uses of your mark.
            </p>
            <div className="dateContainer">
              <div className="date">December 30th, 2022</div>
              <Link href="/articles/Do-I-need-Trademark-Monitoring">
                <a className="orange-btn" style={{ width: "auto", paddingTop: "10px", paddingBottom: "10px" }}>Read
                  more</a>
              </Link>
            </div>
          </div>
          <hr />
          <div className="tag">
            <div className="imageContainer">
              <div className="image">
                <img
                  src={`${publicRuntimeConfig.basePath}/trademarkarticle7.jpg`}
                  alt=""
                  layout="fill"
                />
              </div>
            </div>
            <Link href="/articles/How-to-Fight-Infringement"><a><h4>How to Fight Infringement</h4></a></Link>
            <p>
              Trademark infringement occurs when someone uses a trademark that is similar to your own in a way that is
              likely to cause confusion among consumers. This can be damaging to your business, as it can lead to lost
              sales and a dilution of your brand's value. If you believe that your trademark is being infringed upon, it
              is important to take action to protect your rights.
            </p>
            <div className="dateContainer">
              <div className="date">January 1st, 2023</div>
              <Link href="/articles/How-to-Fight-Infringement">
                <a className="orange-btn" style={{ width: "auto", paddingTop: "10px", paddingBottom: "10px" }}>Read
                  more</a>
              </Link>
            </div>
          </div>
          <hr />
          <div className="tag">
            <div className="imageContainer">
              <div className="image">
                <img
                  src={`${publicRuntimeConfig.basePath}/trademarkarticle8.jpg`}
                  alt=""
                  layout="fill"
                />
              </div>
            </div>
            <Link href="/articles/Top-10-Questions-about-Trademarks"><a><h4>Top 10 Questions about Trademarks</h4></a></Link>
            <p>
              As a business owner, it is important to take steps to protect your brand and intellectual property. One
              way to do this is by trademarking your brand. A trademark is a word, phrase, symbol, or design that
              identifies and distinguishes the source of goods or services. In this article, we will explore the top 10
              questions about trademarking to help you understand the basics of this process and how it can benefit your
              business. Whether you are just starting out or have been in business for years, understanding the answers
              to these questions can help you make informed decisions about protecting your brand.
            </p>
            <div className="dateContainer">
              <div className="date">January 1st, 2023</div>
              <Link href="/articles/Top-10-Questions-about-Trademarks">
                <a className="orange-btn" style={{ width: "auto", paddingTop: "10px", paddingBottom: "10px" }}>Read
                  more</a>
              </Link>
            </div>
          </div>
          <hr />
        </div>
      </div>
    </>
  )
    ;
}

export default Blog;
